__turbopack_context__.v({
  "contentList": "index-module__STTVBW__contentList",
  "inactive": "index-module__STTVBW__inactive",
});
